import { PdfAnnotationAction } from "@/Documents/Models/UI/PdfAnnotationActions";
import { highlightAnnotationStrokeSizes, pencilAnnotationStrokeSizes } from "./AnnotationSettings";
import { FreehandAnnotationSettings } from "./FreehandAnnotationSettings";
import { TextAnnotationSettings } from "./TextAnnotationSettings";

import styles from "./PdfAnnotationSettings.module.scss";

interface PdfAnnotationSettingsProps {
    /** On pdf annotation tool settings selection. */
    onChange: (styles: Record<string, string>) => void;

    /** The selected action. */
    toolbarAction: PdfAnnotationAction;

    /** The pdf annotation tool settings position. */
    position?: { left: number, top: number };

    /** Display the component. */
    isVisible: boolean;
}

/** A React component that display PDF annotation settings as tooltip. */
function PdfAnnotationSettings(props: PdfAnnotationSettingsProps): JSX.Element {
    return (
        <div
            className={`${styles.annotationToolbar} ${!props.isVisible ? "hidden" : ""}`}
            style={{ left: props.position?.left, top: props.position?.top }}
        >
            <TextAnnotationSettings
                onChange={styles => props.onChange(styles)}
                isVisible={props.toolbarAction === PdfAnnotationAction.Text}
            />
            <FreehandAnnotationSettings
                onChange={styles => props.onChange(styles)}
                isVisible={props.toolbarAction === PdfAnnotationAction.Pencil}
                values={pencilAnnotationStrokeSizes}
            />
            <FreehandAnnotationSettings
                onChange={styles => props.onChange(styles)}
                isVisible={props.toolbarAction === PdfAnnotationAction.Highlight}
                values={highlightAnnotationStrokeSizes}
            />
        </div>
    );
}

export { PdfAnnotationSettings };
